import { render, staticRenderFns } from "./JoinSection.vue?vue&type=template&id=6162a7e9&scoped=true"
import script from "./JoinSection.vue?vue&type=script&lang=js"
export * from "./JoinSection.vue?vue&type=script&lang=js"
import style0 from "./JoinSection.vue?vue&type=style&index=0&id=6162a7e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6162a7e9",
  null
  
)

export default component.exports